const appInfo = {
    title: 'Vitome Portal',
    versionString: "0.1.9"
};
export default appInfo;

